module.exports = "/circle_plus_primary-030e89f76c66155ac140f2de4ac7e3e0.svg";